<template>
  <div class="container py-5" style="max-width: 400px">
    <h2 class="mb-4 text-center">Esqueci minha senha</h2>

    <form @submit.prevent="enviar">
      <div class="mb-3">
        <label for="email" class="form-label">E-mail</label>
        <input
          type="email"
          v-model="email"
          class="form-control"
          id="email"
          required
        />
      </div>

      <button type="submit" class="btn btn-primary w-100">
        Enviar instruções
      </button>
    </form>

    <p v-if="mensagem" class="mt-3 text-success">
      {{ mensagem }}
    </p>

    <p v-if="erro" class="mt-3 text-danger">
      {{ erro }}
    </p>

    <router-link to="/login" class="d-block mt-3 text-center">
      Voltar para o login
    </router-link>
  </div>
</template>

<script>
import api from "../services/api";

export default {
  name: "EsqueciSenhaVie",
  data() {
    return {
      email: "",
      mensagem: "",
      erro: "",
    };
  },
  methods: {
    async enviar() {
      this.mensagem = "";
      this.erro = "";

      try {
        const response = await api.post("esqueci_senha.php", {
          email: this.email,
        });

        // backend sempre retorna uma mensagem genérica
        this.mensagem = response.data.mensagem || "Se o e-mail existir, enviaremos instruções.";
      } catch (error) {
        this.erro =
          error?.response?.data?.erro ||
          "Não foi possível processar sua solicitação. Tente novamente.";
      }
    },
  },
};
</script>
